import React from 'react';

export const AddContact = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.7504 6.5C18.7504 8.57107 17.0714 10.25 15.0004 10.25C12.9293 10.25 11.2504 8.57107 11.2504 6.5C11.2504 4.42893 12.9293 2.75 15.0004 2.75C17.0714 2.75 18.7504 4.42893 18.7504 6.5Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M8.25 17.4996C8.25 16.8703 8.7 15.815 9.82746 14.8894C10.9266 13.987 12.6304 13.2501 15 13.2501C17.3696 13.2501 19.0734 13.987 20.1725 14.8894C21.3 15.815 21.75 16.8703 21.75 17.4996V18.5001C21.75 18.699 21.671 18.8898 21.5303 19.0305C21.3897 19.1711 21.1989 19.2501 21 19.2501H9C8.80109 19.2501 8.61032 19.1711 8.46967 19.0305C8.32902 18.8898 8.25 18.699 8.25 18.5001V17.4996Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M4.78888 5.36114V12.9167"
      stroke="black"
      strokeLinecap="square"
      strokeWidth="1.5"
    />
    <path
      d="M8.57778 9.1389H1"
      stroke="black"
      strokeLinecap="square"
      strokeWidth="1.5"
    />
  </svg>
);
